/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LargeLanguageModelsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List available models
     * @returns any Successful request
     * @throws ApiError
     */
    public modelsList(): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Array<{
            provider: string;
            label: string;
            id: '@hf/mistral/mistral-7b-instruct-v0.2' | '@cf/meta/llama-3.3-70b-instruct-fp8-fast';
        }>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/models',
            errors: {
                401: `Unauthorized`,
                500: `Internal error`,
            },
        });
    }
}
